export const CLIENT_ACTIVE_ORG_STORAGE_KEY = "pm_client_active_organization_id";

export function setClientPreferredOrganizationId(organizationId) {
  if (organizationId === null || organizationId === undefined || organizationId === "") {
    return;
  }
  sessionStorage.setItem(CLIENT_ACTIVE_ORG_STORAGE_KEY, String(organizationId));
}

export function clearClientPreferredOrganizationId() {
  sessionStorage.removeItem(CLIENT_ACTIVE_ORG_STORAGE_KEY);
}

export function applyPreferredOrganizationToUserPayload(user) {
  if (!user) return user;

  const raw = sessionStorage.getItem(CLIENT_ACTIVE_ORG_STORAGE_KEY);
  if (!raw) return user;

  const preferredId = Number(raw);
  if (!Number.isFinite(preferredId)) return user;

  const orgList = user.organization || [];
  const metaList = user.metadata || [];

  const hasOrgRecord = orgList.some(
    (o) => Number(o?.organization_id) === preferredId
  );
  const matchedOrgUser = metaList.find(
    (m) => Number(m?.organization_id) === preferredId
  );

  if (!hasOrgRecord || !matchedOrgUser?.organization_user_id) {
    return user;
  }

  const dd = orgList.find(
    (o) => Number(o?.organization_id) === preferredId
  );

  const uaoSrc =
    user.user_active_organization || user.activeOrganization || {};
  const nextUao =
    typeof uaoSrc === "object" && uaoSrc !== null && !Array.isArray(uaoSrc)
      ? {
          ...uaoSrc,
          organization_id: preferredId,
          user_current_active_organization_id: preferredId,
        }
      : {
          organization_id: preferredId,
          user_current_active_organization_id: preferredId,
        };

  let nextActive = user.activeOrganization;
  if (nextActive && typeof nextActive === "object" && !Array.isArray(nextActive)) {
    nextActive = {
      ...nextActive,
      organization_id: preferredId,
      user_current_active_organization_id: preferredId,
    };
  } else {
    nextActive = nextUao;
  }

  return {
    ...user,
    organization: dd ?? user.organization,
    organizationuser: matchedOrgUser,
    user_active_organization: nextUao,
    activeOrganization: nextActive,
  };
}
